import { render } from "./adopteVue.vue?vue&type=template&id=6f9ce2ca"
import script from "./adopteVue.vue?vue&type=script&lang=js"
export * from "./adopteVue.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__